
(function () {
  'use strict';

  /* ---------------------------------------------------------
   * Helpers
   * --------------------------------------------------------- */

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getUpsellData() {
    var el = document.querySelector('[data-product-upsell-json]');

    if (!el) {
      return null;
    }

    try {
      var data = JSON.parse(el.textContent);

      if (
        !data ||
        !data.accessories ||
        !Array.isArray(data.accessories) ||
        !data.accessories.length
      ) {
        return null;
      }

      return data;
    } catch (error) {
      console.error(
        'product-upsell: could not parse upsell data',
        error
      );

      return null;
    }
  }

  /* ---------------------------------------------------------
   * Build Upsell Modal
   * --------------------------------------------------------- */

  function buildModal(data, onDone) {
    var overlay = document.createElement('div');

    overlay.className = 'upsell-modal-overlay';

    var rows = data.accessories
      .map(function (acc, idx) {
        var price = Number(acc.price || 0);
        var compareAtPrice = Number(acc.compareAtPrice || 0);

        var hasSale = compareAtPrice > price;

        var priceHtml = hasSale
          ? '<span class="upsell-price-was">' +
            money(compareAtPrice) +
            '</span> ' +
            '<span class="upsell-price-now">' +
            money(price) +
            '</span>'
          : '<span class="upsell-price-now">' +
            money(price) +
            '</span>';

        return (
          '<label class="upsell-row">' +

            '<input ' +
              'type="checkbox" ' +
              'class="upsell-checkbox" ' +
              'data-variant-id="' +
              escapeHtml(acc.variantId) +
              '" ' +
              'data-idx="' +
              idx +
              '">' +

            '<img ' +
              'class="upsell-row-img" ' +
              'src="' +
              escapeHtml(acc.image) +
              '" ' +
              'alt="' +
              escapeHtml(acc.title) +
              '" ' +
              'loading="lazy">' +

            '<span class="upsell-row-info">' +

              '<span class="upsell-row-title">' +
                escapeHtml(acc.title) +
              '</span>' +

              '<span class="upsell-row-price">' +
                priceHtml +
              '</span>' +

            '</span>' +

          '</label>'
        );
      })
      .join('');

    overlay.innerHTML =
      '<div ' +
        'class="upsell-modal" ' +
        'role="dialog" ' +
        'aria-modal="true" ' +
        'aria-label="Add compatible accessories">' +

        '<button ' +
          'type="button" ' +
          'class="upsell-close" ' +
          'aria-label="Close">' +
          '&times;' +
        '</button>' +

        '<h2 class="upsell-title">' +
          'Complete your ' +
          escapeHtml(data.productTitle) +
        '</h2>' +

        '<p class="upsell-subtitle">' +
          'Customers who buy this also add:' +
        '</p>' +

        '<div class="upsell-rows">' +
          rows +
        '</div>' +

        '<div class="upsell-actions">' +

          '<button ' +
            'type="button" ' +
            'class="upsell-btn upsell-btn-secondary" ' +
            'data-action="skip">' +
            'No thanks, just the item' +
          '</button>' +

          '<button ' +
            'type="button" ' +
            'class="upsell-btn upsell-btn-primary" ' +
            'data-action="add">' +
            'Add to cart' +
          '</button>' +

        '</div>' +

      '</div>';

    document.body.appendChild(overlay);
    document.body.classList.add('upsell-modal-open');

    var finished = false;

    function finish(items) {
      if (finished) {
        return;
      }

      finished = true;

      overlay.remove();
      document.body.classList.remove('upsell-modal-open');

      onDone(items || []);
    }

    /* Close button */

    var closeButton = overlay.querySelector('.upsell-close');

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        finish([]);
      });
    }

    /* Click outside modal */

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        finish([]);
      }
    });

    /* Escape key */

    function handleEscape(event) {
      if (event.key === 'Escape') {
        document.removeEventListener(
          'keydown',
          handleEscape
        );

        finish([]);
      }
    }

    document.addEventListener(
      'keydown',
      handleEscape
    );

    /* No thanks */

    var skipButton = overlay.querySelector(
      '[data-action="skip"]'
    );

    if (skipButton) {
      skipButton.addEventListener('click', function () {
        document.removeEventListener(
          'keydown',
          handleEscape
        );

        finish([]);
      });
    }

    /* Add selected products */

    var addButton = overlay.querySelector(
      '[data-action="add"]'
    );

    if (addButton) {
      addButton.addEventListener('click', function () {
        var checked = Array.prototype.slice.call(
          overlay.querySelectorAll(
            '.upsell-checkbox:checked'
          )
        );

        var extraItems = checked
          .map(function (checkbox) {
            var variantId = parseInt(
              checkbox.getAttribute(
                'data-variant-id'
              ),
              10
            );

            if (!variantId) {
              return null;
            }

            return {
              id: variantId,
              quantity: 1
            };
          })
          .filter(Boolean);

        document.removeEventListener(
          'keydown',
          handleEscape
        );

        finish(extraItems);
      });
    }
  }

  /* ---------------------------------------------------------
   * Get Dawn Cart Drawer Sections
   * --------------------------------------------------------- */

  function getCartDrawerSections(cartDrawer) {
    /*
     * Dawn exposes getSectionsToRender().
     *
     * This is preferable to hard-coding section IDs because
     * different Dawn versions can have different section IDs.
     */

    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function'
    ) {
      try {
        var sections = cartDrawer.getSectionsToRender();

        if (
          Array.isArray(sections) &&
          sections.length
        ) {
          return sections
            .map(function (section) {
              return section.id;
            })
            .filter(Boolean);
        }
      } catch (error) {
        console.warn(
          'product-upsell: unable to get Dawn cart sections',
          error
        );
      }
    }

    /*
     * Fallback for Dawn versions that don't expose
     * getSectionsToRender().
     */

    return [
      'cart-drawer',
      'cart-icon-bubble'
    ];
  }

  /* ---------------------------------------------------------
   * Add Items To Cart
   * --------------------------------------------------------- */

  function addItemsToCart(items) {
    var root = getShopifyRoot();

    var cartDrawer = document.querySelector(
      'cart-drawer'
    );

    var sections = getCartDrawerSections(
      cartDrawer
    );

    /*
     * Shopify allows up to 5 sections in a bundled
     * section rendering request.
     */

    sections = sections.slice(0, 5);

    var requestBody = {
      items: items,

      /*
       * Ask Shopify to render the cart sections
       * AFTER the items have been added.
       */
      sections: sections,

      /*
       * Render the sections using the cart page
       * context.
       *
       * This is especially important when the add
       * happens from the product page.
       */
      sections_url: root + 'cart'
    };

    console.log(
      'product-upsell: adding items',
      items
    );

    console.log(
      'product-upsell: requested sections',
      sections
    );

    return fetch(root + 'cart/add.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify(requestBody)
    }).then(function (response) {
      return response.text().then(function (text) {
        var data;

        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error(
            'Shopify returned an invalid cart response.'
          );
        }

        if (!response.ok) {
          throw data;
        }

        console.log(
          'product-upsell: cart response',
          data
        );

        return data;
      });
    });
  }

  /* ---------------------------------------------------------
   * Render / Open Dawn Cart Drawer
   * --------------------------------------------------------- */

  function openCartDrawer(cartResponse) {
    var cartDrawer = document.querySelector(
      'cart-drawer'
    );

    if (!cartDrawer) {
      console.warn(
        'product-upsell: <cart-drawer> not found'
      );

      return false;
    }

    /*
     * Shopify should return sections after a successful
     * bundled section rendering request.
     */

    if (
      !cartResponse ||
      !cartResponse.sections
    ) {
      console.warn(
        'product-upsell: no sections returned by Shopify',
        cartResponse
      );

      return false;
    }

    /*
     * Log the returned sections so debugging is easy.
     */

    console.log(
      'product-upsell: returned cart sections',
      cartResponse.sections
    );

    /*
     * Dawn's renderContents() updates the drawer markup
     * and opens the drawer.
     */

    if (
      typeof cartDrawer.renderContents ===
      'function'
    ) {
      try {
        cartDrawer.renderContents(
          cartResponse
        );

        /*
         * Very important for the first-add case.
         *
         * Dawn initially renders:
         *
         * <cart-drawer class="drawer is-empty">
         *
         * When the first product is added, the returned
         * HTML contains products, but the existing custom
         * element can still have is-empty.
         */

        cartDrawer.classList.remove(
          'is-empty'
        );

        /*
         * Dawn's cart-drawer-items can also have the
         * is-empty class in some versions.
         */

        var cartDrawerItems =
          cartDrawer.querySelector(
            'cart-drawer-items'
          );

        if (cartDrawerItems) {
          cartDrawerItems.classList.remove(
            'is-empty'
          );
        }

        /*
         * If Dawn's renderContents did not open the
         * drawer for some reason, explicitly open it.
         */

        if (
          typeof cartDrawer.open ===
          'function'
        ) {
          setTimeout(function () {
            if (
              !cartDrawer.classList.contains(
                'active'
              )
            ) {
              cartDrawer.open();
            }
          }, 0);
        }

        return true;
      } catch (error) {
        console.error(
          'product-upsell: cart drawer render failed',
          error
        );

        return false;
      }
    }

    return false;
  }

  /* ---------------------------------------------------------
   * Fallback Cart Refresh
   * --------------------------------------------------------- */

  function refreshCartDrawerFallback() {
    var root = getShopifyRoot();

    var cartDrawer = document.querySelector(
      'cart-drawer'
    );

    if (!cartDrawer) {
      return Promise.resolve(false);
    }

    var sections =
      getCartDrawerSections(cartDrawer);

    sections = sections.slice(0, 5);

    if (!sections.length) {
      return Promise.resolve(false);
    }

    var url =
      root +
      '?sections=' +
      encodeURIComponent(
        sections.join(',')
      );

    console.warn(
      'product-upsell: refreshing cart drawer using fallback Section Rendering API'
    );

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Unable to refresh cart drawer.'
          );
        }

        return response.json();
      })
      .then(function (sectionResponse) {
        /*
         * renderContents() expects an object containing
         * a sections property.
         */

        var currentCart = {
          sections: sectionResponse
        };

        if (
          typeof cartDrawer.renderContents ===
          'function'
        ) {
          cartDrawer.renderContents(
            currentCart
          );

          cartDrawer.classList.remove(
            'is-empty'
          );

          var cartDrawerItems =
            cartDrawer.querySelector(
              'cart-drawer-items'
            );

          if (cartDrawerItems) {
            cartDrawerItems.classList.remove(
              'is-empty'
            );
          }

          if (
            typeof cartDrawer.open ===
            'function'
          ) {
            cartDrawer.open();
          }

          return true;
        }

        return false;
      })
      .catch(function (error) {
        console.error(
          'product-upsell: fallback drawer refresh failed',
          error
        );

        return false;
      });
  }

  /* ---------------------------------------------------------
   * Cart Error Message
   * --------------------------------------------------------- */

  function getErrorMessage(error) {
    if (!error) {
      return 'Sorry, something went wrong adding the product to your cart.';
    }

    if (typeof error === 'string') {
      return error;
    }

    if (error.description) {
      return error.description;
    }

    if (error.message) {
      return error.message;
    }

    if (error.status) {
      return (
        'Unable to add the product to your cart. ' +
        'Please try again.'
      );
    }

    return (
      'Sorry, something went wrong adding the product to your cart.'
    );
  }

  /* ---------------------------------------------------------
   * Submit Handler
   * --------------------------------------------------------- */

  function handleSubmit(
    event,
    form,
    data
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();

    /*
     * Prevent the form from being submitted by the
     * browser/theme while the upsell modal is open.
     */

    var formData = new FormData(form);

    var mainVariantId = parseInt(
      formData.get('id'),
      10
    );

    var mainQuantity = parseInt(
      formData.get('quantity') || '1',
      10
    );

    if (!mainVariantId) {
      console.error(
        'product-upsell: main variant ID not found'
      );

      return;
    }

    if (!mainQuantity || mainQuantity < 1) {
      mainQuantity = 1;
    }

    var submitButton = form.querySelector(
      '[type="submit"]'
    );

    /*
     * Prevent duplicate submissions immediately.
     */

    if (
      submitButton &&
      submitButton.disabled
    ) {
      return;
    }

    if (submitButton) {
      submitButton.setAttribute(
        'disabled',
        'disabled'
      );

      submitButton.setAttribute(
        'aria-busy',
        'true'
      );
    }

    /*
     * Show upsell modal.
     */

    buildModal(
      data,
      function (extraItems) {
        var items = [
          {
            id: mainVariantId,
            quantity: mainQuantity
          }
        ].concat(extraItems || []);

        console.log(
          'product-upsell: final cart items',
          items
        );

        addItemsToCart(items)
          .then(function (cartResponse) {
            /*
             * First attempt:
             * Use the bundled sections returned by
             * /cart/add.js.
             */

            var openedDrawer =
              openCartDrawer(
                cartResponse
              );

            /*
             * If Shopify didn't return usable sections,
             * perform a second Section Rendering API
             * request.
             *
             * This is mainly a safety net for custom Dawn
             * versions or section-rendering failures.
             */

            if (!openedDrawer) {
              return refreshCartDrawerFallback()
                .then(function (fallbackOpened) {
                  if (!fallbackOpened) {
                    /*
                     * Last fallback:
                     * go to cart page.
                     */

                    var root =
                      getShopifyRoot();

                    window.location.href =
                      root + 'cart';

                    return;
                  }

                  if (submitButton) {
                    submitButton.removeAttribute(
                      'disabled'
                    );

                    submitButton.removeAttribute(
                      'aria-busy'
                    );
                  }
                });
            }

            if (submitButton) {
              submitButton.removeAttribute(
                'disabled'
              );

              submitButton.removeAttribute(
                'aria-busy'
              );
            }
          })
          .catch(function (error) {
            console.error(
              'product-upsell: add to cart failed',
              error
            );

            /*
             * Do not use the native alert().
             *
             * The alert was causing the unwanted browser
             * popup you were seeing previously.
             */

            var message =
              getErrorMessage(error);

            /*
             * Use a normal console error and, if available,
             * Dawn's cart drawer error container.
             */

            var cartDrawer =
              document.querySelector(
                'cart-drawer'
              );

            var errorElement =
              cartDrawer &&
              cartDrawer.querySelector(
                '.cart-drawer__errors'
              );

            if (errorElement) {
              errorElement.textContent =
                message;

              errorElement.removeAttribute(
                'hidden'
              );
            } else {
              console.error(
                'product-upsell:',
                message
              );
            }

            if (submitButton) {
              submitButton.removeAttribute(
                'disabled'
              );

              submitButton.removeAttribute(
                'aria-busy'
              );
            }
          });
      }
    );
  }

  /* ---------------------------------------------------------
   * Initialize
   * --------------------------------------------------------- */

  function initProductUpsell() {
    var data = getUpsellData();

    /*
     * If this product has no compatible products,
     * do absolutely nothing.
     *
     * Normal Dawn add-to-cart will continue.
     */

    if (!data) {
      return;
    }

    var forms =
      document.querySelectorAll(
        'form[action*="/cart/add"]'
      );

    if (!forms.length) {
      console.warn(
        'product-upsell: no add-to-cart forms found'
      );

      return;
    }

    forms.forEach(function (form) {
      /*
       * Avoid attaching the listener twice.
       */

      if (
        form.dataset.productUpsellInitialized ===
        'true'
      ) {
        return;
      }

      form.dataset.productUpsellInitialized =
        'true';

      /*
       * Capture phase = true.
       *
       * This lets us intercept the submit before
       * Dawn/product-form.js handles it.
       */

      form.addEventListener(
        'submit',
        function (event) {
          handleSubmit(
            event,
            form,
            data
          );
        },
        true
      );
    });

    console.log(
      'product-upsell: initialized'
    );
  }

  /* ---------------------------------------------------------
   * DOM Ready
   * --------------------------------------------------------- */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initProductUpsell
    );
  } else {
    initProductUpsell();
  }
})();
